module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"rename modal":"Modal umbenennen","name":"Name","background color":"Hintergrundfarbe","font":"Schriftart","add font long":"Fügen Sie eine Schriftart hinzu, indem Sie sie hier ablegen.","add font short":"Als Schriftart hinzufügen."}}')
  delete Component.options._Ctor
}
